/** an array of entity hashes pointing to cards in this group */
export type CardGroup = Array<string>;

export const CARD_GROUP = "CardGroup";
